/**
 * Forme canonique JSON de la caisse : copie exacte de
 * backend/src/services/caisse/canonicalJson.js (sous-ensemble de JCS,
 * RFC 8785). Cles triees (ordre des unites UTF-16), aucun espace, chaines
 * echappees comme JSON.stringify, ENTIERS seulement. Le serveur signe ces
 * octets : un octet de difference et la signature du catalogue echoue.
 * Les tests (sync/__tests__/canonicalJson.test.js) comparent les deux
 * implementations sur les memes valeurs.
 */

export function canonicalize(value) {
    if (value === null) return 'null';
    switch (typeof value) {
        case 'boolean':
            return value ? 'true' : 'false';
        case 'string':
            return JSON.stringify(value);
        case 'number':
            if (!Number.isSafeInteger(value)) {
                throw new TypeError('Forme canonique : seuls les entiers sont permis');
            }
            return String(value);
        case 'object': {
            if (Array.isArray(value)) return `[${value.map(canonicalize).join(',')}]`;
            const keys = Object.keys(value).sort();
            return `{${keys.map((key) => `${JSON.stringify(key)}:${canonicalize(value[key])}`).join(',')}}`;
        }
        default:
            throw new TypeError(`Forme canonique : type ${typeof value} non permis`);
    }
}
